export default "/images/framework/QRCode.add83238.svg?add83238";